<script>
    import { onMount, onDestroy } from 'svelte';

    import { slide, fly } from 'svelte/transition';
    import { quintOut } from 'svelte/easing';

    import { idb } from "../db";
    import { user } from '../store/authStore';
    import { page, modal } from '../store/nav';
    import { lists } from '../store/lists';

    import Icon from "../components/icon.svelte";

    import { createId } from '../js/helper';

    export let back_nav = false;

    let tab = 'active';

    onMount(async () => {
        await lists.init();
    });

    $: if( $lists ){
        if( Array.isArray($lists))  $lists.sort((a,b) => (a.lastUpdated < b.lastUpdated) ? 1 : ((b.lastUpdated < a.lastUpdated) ? -1 : 0));
    }

    onDestroy(() => {
        idb.save('pc_lists', $lists);
    });

    const add = () => {
        const newList = {
            "uid":createId.md(),
            "name":"Select store",
            "date":"2022-05-19",
            "status":"active",
            "storeUid":null,
            "storeName":"Select Store",
            "storeLogo":null,
            "assignedUser":null,
            "progress":0,
            "lastUpdated":Date.now(),
            "createdOn":Date.now()
        }
        lists.add(newList);
        page.route(`/lists/items/item-generic?list_uid=${newList.uid}&redirect=/lists/items/store`);
    }
</script>

<section id="list" in:fly="{{ x: back_nav ? -250 : 250, duration: 150 }}"  out:fly="{{ x: 250, duration: 150, delay:150 }}" class="flex flex-col justify-between bg-primary fixed top-0 left-0 h-screen w-screen px-10">
    <section id="top-bar" class="flex mt-12 justify-between">
        <div id="back-btn" class="place-self-center" on:click={() => page.back('/menu?back_nav=true')} >
            <svg viewBox="0 0 18 18" class="fill-secondary h-5" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7803 2.46967C12.0732 2.76256 12.0732 3.23744 11.7803 3.53033L6.31066 9L11.7803 14.4697C12.0732 14.7626 12.0732 15.2374 11.7803 15.5303C11.4874 15.8232 11.0126 15.8232 10.7197 15.5303L4.71967 9.53033C4.42678 9.23744 4.42678 8.76256 4.71967 8.46967L10.7197 2.46967C11.0126 2.17678 11.4874 2.17678 11.7803 2.46967Z"/>
            </svg>
        </div>
        <div id="title" class="place-self-center">Shopping</div>
        <div id="title-menu"class="place-self-center w-5" >
            <!--svg class="fill-secondary h-5" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5 3C10.5 3.82843 9.82843 4.5 9 4.5C8.17157 4.5 7.5 3.82843 7.5 3C7.5 2.17157 8.17157 1.5 9 1.5C9.82843 1.5 10.5 2.17157 10.5 3Z"/>
                <path d="M10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9Z"/>
                <path d="M9 16.5C9.82843 16.5 10.5 15.8284 10.5 15C10.5 14.1716 9.82843 13.5 9 13.5C8.17157 13.5 7.5 14.1716 7.5 15C7.5 15.8284 8.17157 16.5 9 16.5Z"/>
            </svg-->
        </div>
    </section>
    <section id="tabs" class="flex mt-8 space-x-9 text-sm text-secondary justify-center">
        <div id="recurring-btn" class="flex space-x-2 border border-shade p-2 rounded-sm" on:click|stopPropagation={() => page.route(`/lists/recurring`)}>
            <Icon name="recurring" class="w-4" />
            <span class="place-self-center cursor-pointer">Recurring</span>
        </div>
        <div id="monitoring-btn" class="flex space-x-2 border border-shade p-2 rounded-sm" on:click|stopPropagation={() => modal.open('/message?anchor=bottom&text=The price tracking feature is not available in this alpha version. We\'re hard at work to release it as soon as possible. Thank you for your patience ❤︎')}>
            <Icon name="monitoring" class="w-4 fill-shade" />
            <span class="place-self-center text-shade cursor-pointer">Price tracking</span>
        </div>
        
    </section>
    <section class="mt-7 flex flex-col grow">
        <span class="text-md text-shade">Active lists:</span>
        <section id="main" class="flex flex-col mt-7 grow space-y-10">
            {#if $lists}
            {#each $lists as list }
            {#if list.status == tab}
                <section class="list-row flex" on:click|stopPropagation={() => page.route('/lists/items?list_uid='+list.uid)}>
                    <section class="list-logo">
                        <img src="/img/stores/{list.storeLogo}.png" alt="" class="w-7">
                    </section>
                    <section class="list-name ml-3.5 capitalize grow">
                        {list.storeName}
                    </section>
                    <section class="list-end flex">
                        {#if list.storeName == "whole foods" ||  list.storeName == "amazon fresh"}
                            <img src="/img/icon/buy-online.png" on:click|stopPropagation={() => modal.open(`/online-fulfillment?list_uid=${list.uid}&store_name=${list.storeName}&store_logo=${list.storeLogo}&anchor=bottom`)} class="mr-1.5 w-5 h-5" alt="">
                        {/if}
                        <span class="text-shade italic text-sm">{list.progress} %</span>
                    </section>
                </section>
            {/if}
            {/each}
            {/if}
    
        </section>
        <section id="footer" class="m-auto my-12 cursor-pointer" on:click="{add}">
            New list
        </section>
    </section>
</section>


<style>

</style>